import { ActualParameter } from "./ActualParameter";
import { Participant } from "./Participant";

export class ComponentParticipant extends Participant {
    name: string;
    metadataId: string;
    methodCode: string;
    methodName: string;
    actualParameters: Array<ActualParameter>;
}